import { combineReducers } from "@reduxjs/toolkit";
import favicon from "./faviconSlice";
const reducer = combineReducers({
  favicon,
});

export default reducer;
